import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '@/config/constants';
import { useThemeStore } from '@/store/theme.store';

function normalizePathname(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}

function isAuthShellPath(pathname: string): boolean {
  const p = normalizePathname(pathname);
  return p === ROUTES.LOGIN || p === ROUTES.FORGOT_PASSWORD;
}

/**
 * Applies theme to document on mount and when theme changes.
 * Login and forgot-password always use the Netcore palette; other routes use the persisted theme.
 */
const ThemeInitializer = () => {
  const theme = useThemeStore((s) => s.theme);
  const { pathname } = useLocation();

  useEffect(() => {
    const effective = isAuthShellPath(pathname) ? 'netcore' : theme;
    document.documentElement.setAttribute('data-theme', effective);
  }, [theme, pathname]);

  return null;
};

export default ThemeInitializer;
